import { HTMLAttributes, ReactElement, ReactNode } from "react";
import clsx from "clsx";
import "./filters.scss";

export const JournalSectionFilters = ({
  children,
  className,
  ...rest
}: {
  children: ReactNode | ReactElement;
  className?: string;
} & HTMLAttributes<HTMLDivElement>) => {
  return (
    <div className={clsx("journal-section-filters", className)} {...rest}>
      {children}
    </div>
  );
};
